import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./firebaseConfig";
import "./utils/configuration";
import AppRoutes from "./routes/AppRoutes";
// import MaintenanceNotice from "./components/shared/MaintenanceNotice";

const App: React.FC = () => {
  // return(
  //   <MaintenanceNotice />
  // );
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

export default App;
